(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["film-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Product videos are muted with no controls by default. Unmute when the customer presses play and add a sound toggle. */
if (!window.__filmSound) {
 window.__filmSound = true;
 var enhance = function (v) {
  if (v.__filmSound) return;
  v.__filmSound = true;
  var host = v.closest('deferred-media');
  if (!host) return;
  if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
  v.muted = false;
  v.volume = 1;
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'film-sound-btn';
  var label = function () {
   b.textContent = v.muted ? 'Sound off' : 'Sound on';
   b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
  };
  b.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; label(); });
  v.addEventListener('volumechange', label);
  label();
  host.appendChild(b);
 };
 var scan = function () { document.querySelectorAll('.product-media deferred-media video').forEach(enhance); };
 new MutationObserver(scan).observe(document.documentElement,{ childList: true, subtree: true });
 scan();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stocking-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stocking-order-options')) {
 customElements.define('stocking-order-options',class extends HTMLElement {
  connectedCallback() {
   this.addEventListener('change',event=>{
    const select=event.target;
    if(select instanceof HTMLSelectElement){
     const form=this.closest('form');
     form.querySelector('input[name="id"]').value=select.value;
     form.querySelector('[data-stocking-total]').textContent=select.selectedOptions[0].dataset.total;
    }
   });
  }
 });
}
/* Express checkout (Buy it now / Shop Pay / Apple Pay) must not skip the required names box. */
if (!window.__stockingExpressGuard) {
 window.__stockingExpressGuard = true;
 document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;
  if (!t.closest('shopify-accelerated-checkout, .shopify-payment-button')) return;
  var box = t.closest('product-form-component');
  var f = box && box.querySelector('form');
  if (f && !f.checkValidity()) {
   e.preventDefault();
   e.stopImmediatePropagation();
   f.reportValidity();
  }
 }, true);
}
  } catch(e) { console.error(e); }
})();

})();
